import { memo } from 'react'
import { PictureIcon } from '@/assets'
import { Button } from '@/components/Inputs'
import { Box } from '@/components/Layout'
import { imageGalleryButtonStyles as styles } from './ImageGalleryButton.style'
import { ImageGalleryButtonProps } from './ImageGalleryButton.types'

function ImageGalleryButton({ count, onClick }: ImageGalleryButtonProps) {
  return (
    <Box sx={styles.wrapper}>
      <Button
        color="secondary"
        size="small"
        sx={styles.button}
        textProps={{ sx: styles.buttonText }}
        startIcon={<Box sx={styles.buttonIcon} component={PictureIcon} />}
        onClick={onClick}>
        {count} +
      </Button>
    </Box>
  )
}

export default memo(ImageGalleryButton)
